module.exports = __webpack_public_path__ + "img/intermediate-products.50825df2.png";